/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { LoginResponse } from '../model/models';
import { OperatorLoginForm } from '../model/models';
import { RefreshTokenForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface LoginOperatoreRequestParams {
    operatorLoginForm: OperatorLoginForm;
    xRecaptchaToken?: string;
}

export interface RefreshSessioneOperatoreRequestParams {
    refreshTokenForm: RefreshTokenForm;
}


export interface AutenticazioneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Login operatore via ROPC proxy a Keycloak
     * Riceve email e password, verifica stato utente locale, poi proxya a KC token endpoint. Non disponibile per i CITTADINO federati (solo SPID/CIE-ID).
     * @endpoint post /api/v1/auth/login
* @param requestParameters
     */
    loginOperatore(requestParameters: LoginOperatoreRequestParams, extraHttpRequestParams?: any): Observable<LoginResponse>;

    /**
     * Logout utente con revoca sessioni KC
     * Revoca tutte le sessioni Keycloak dell\&#39;utente autenticato.
     * @endpoint put /api/v1/auth/logout
*/
    logoutUtente(extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Rinnovo sessione via refresh token Keycloak
     * Scambia il refresh token di sessione con una nuova coppia di token. Pubblico (senza reCAPTCHA): il refresh token e\&#39; la credenziale. Rifiuta i refresh token offline (passkey) e gli utenti anonimizzati, disabilitati, bloccati o non attivati.
     * @endpoint post /api/v1/auth/refresh
* @param requestParameters
     */
    refreshSessioneOperatore(requestParameters: RefreshSessioneOperatoreRequestParams, extraHttpRequestParams?: any): Observable<LoginResponse>;

}
